import Footer from "../components/Footer.tsx";
import { errorParser, fetchJSON } from "../components/Loaders.ts";
import Logo from "../components/Logo.tsx";
import Password from "../components/Password.tsx";
import { Login as LoginData, useUIStore } from "../components/Store.ts";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

const loginAction = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) =>
  await fetchJSON<LoginData>({
    url: "/api/login",
    method: "POST",
    content: { email, password },
  })
    .then((result) => {
      console.debug("Login result", result.data);
      useUIStore.setState((s) => ({ ...s, loginData: result.data }));
      return Promise.resolve(result);
    })
    .catch((error) => Promise.reject(errorParser("login", error)));

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const searchParams = useSearch({ strict: false });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const redirectPath = searchParams.redirect ?? "/";
  const navigate = useNavigate();
  const [loginFailure, setLoginFailure] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    document.title = "Freshet: Login";
  }, []);

  return (
    <main
      id="login-panel"
      role="main"
      className="container"
      style={{ paddingTop: "5rem" }}
      data-testid="login-panel"
    >
      <div>
        <h1>
          <Logo />
          Freshet
        </h1>
        <p className="lead">
          Login to Freshet (or{" "}
          <Link id="register-link" to="/Register">
            register
          </Link>
          )
        </p>
        <form>
          <div className="form-group">
            <label htmlFor="input-email">Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setLoginFailure(false);
                setEmail(e.target.value);
              }}
              className="form-control"
              required={true}
              id="input-email"
              aria-describedby="emailHelp"
              placeholder="Enter email"
            />
          </div>
          <div className="form-group">
            <Password
              password={password}
              setPassword={setPassword}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              clearFailure={() => setLoginFailure(false)}
            />
            <Link id="forgot-password-link" to="/ForgotPassword">
              Forgot password?
            </Link>
          </div>
          <br />
          <div
            data-testid="login-failure"
            className="alert alert-danger"
            role="alert"
            style={{ display: loginFailure ? "block" : "none" }}
          >
            Login failure. Do you have the correct email or password?
          </div>
          <button
            id="login-button"
            data-testid="login-button"
            type="submit"
            className="btn btn-primary"
            onClick={(e) => {
              void loginAction({ email, password })
                .then(() => {
                  console.debug("login navigate", redirectPath);
                  return navigate({ to: redirectPath, replace: true });
                })
                .catch((err) => {
                  console.warn("login failure", err);
                  setLoginFailure(true);
                });
              e.preventDefault();
            }}
          >
            Login
          </button>
        </form>
      </div>
      <Footer />
    </main>
  );
}

export default Login;
